import {connect} from 'react-redux';
import {getTranslation} from "../../../reducers/common/localization";
import {Utils} from "../../../utils/utils";
import EditAccreditationRequest from "./EditAccreditationRequest";
import {
    getContinentsData, getCountriesData, getCurrentContinent, setCurrentContinent,
    setCurrentContinentByCountry
} from "../../../reducers/common/location";
import {fetchGetVIDs, getVIDsData, loadingVIDs} from "../../../reducers/applicantAccreditations/VIDs";
import {fetchGetTitleLangs, getOptionalTitleLangsData, loadingTitleLangs} from "../../../reducers/common/titleLangs";
import {getUserEmail} from "../../../reducers/account/userData";
import {fetchGetLevels, getLevelsData, loadingLevels} from "../../../reducers/common/levels";
import {
    fetchAccreditationRequestById,
    getAccreditationRequestDataFormatted, loadingAccreditationRequest, onUpdateAccreditationRequest
} from "../../../reducers/applicantAccreditations/accreditationRequest";
import {getSubmitFormSuccessStatus} from "../../../reducers/common/submitForm";

const mapStateToProps = (state, {location}) => {
    return {
        id: Utils.getParamsFromLocationSearch(location.search).id,
        data: getAccreditationRequestDataFormatted(state),
        loading: loadingAccreditationRequest(state),
        translation: getTranslation(state),
        additionalLangs: getOptionalTitleLangsData(state),
        loadingAdditionalLangs: loadingTitleLangs(state),
        levels: getLevelsData(state),
        loadingLevels: loadingLevels(state),
        VIDs: getVIDsData(state),
        loadingVIDs: loadingVIDs(state),
        continentCode: getCurrentContinent(state),
        continents: getContinentsData(state),
        countries: getCountriesData(state),
        email: getUserEmail(state),
        success: getSubmitFormSuccessStatus(state)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onGetAccreditationRequestData: (id) => {
            dispatch(fetchAccreditationRequestById(id))
        },
        onProcess: (id, data) => {
            dispatch(onUpdateAccreditationRequest(id, data, true));
        },
        onGetAdditionalLangs: () => {
            dispatch(fetchGetTitleLangs());
        },
        onGetLevels: () => {
            dispatch(fetchGetLevels());
        },
        onGetVIDs: () => {
            dispatch(fetchGetVIDs())
        },
        onContinentSet: (continentCode) => {
            dispatch(setCurrentContinent(continentCode));
        },
        onContinentSetByCountry: (countryCode) => {
            dispatch(setCurrentContinentByCountry(countryCode));
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(EditAccreditationRequest);



// WEBPACK FOOTER //
// ./src/components/applicantAccreditationsManagement/editAccreditationRequest/EditAccreditationRequest.container.js